import styled, { css } from 'styled-components';
import PrimaryButton from '@carvana/showroom-forms/Button/Primary';
import SecondaryButton from '@carvana/showroom-forms/Button/Secondary';

//  breakpoints
//  https://showroom.cvnacorp.com/teams/sell-to-carvana/breakpoints
//
//    xs -- 375px
//    sm -- 768px
//    md -- 1024px
//    lg -- 1280px
//    xl -- 1920px

const CurrentPaymentWrapper = styled.div`
  display: flex;
  justify-content: left;
  flex-direction: column;
  align-content: center;
  border-radius: ${(props) => props.theme.border.radius};
  background-color: ${(props) => props.theme.color.neutral.v100};
  padding: 24px 24px 0;
`;

const CurrentPaymentTitle = styled.h3`
  align-items: center;
  display: flex;
  flex-direction: row;
  color: ${(props) => props.theme.color.primary.v400};
  padding: 0 0 16px 0;
  margin: 0;
  font-weight: bold;
  font-size: 14px;
  line-height: 16px;
  text-transform: uppercase;
  width: 100%;
`;

const PaymentTooltip = styled.img`
  margin-left: 4px;
  vertical-align: unset;
`;

const CurrentPaymentDetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 0px;

  @media (min-width: 321px) {
    flex-direction: row;
    margin-bottom: 0px;
  }
`;

const CurrentPaymentDetails = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 170px;
  margin-right: 16px;

  @media (min-width: 320px) {
    min-width: 145px;

    &:first-child {
      margin-right: 5px;
    }

    &.turn-off-pay:first-child {
      margin-right: 5px;
    }
  }

  @media (min-width: 375px) {
    margin-bottom: 0px;
    min-width: 145px;

    &:first-child {
      margin-right: 20px;
    }

    &.turn-off-pay:first-child {
      margin-right: 20px;
    }
  }

  @media (min-width: 768px) {
    margin-bottom: 0px;

    &:first-child {
      margin-right: 40px;
      min-width: 185px;
    }

    &.turn-off-pay:first-child {
      margin-right: 40px;
      min-width: 185px;
    }
  }

  @media (min-width: 1024px) {
    margin-bottom: 0px;
    min-width: 185px;

    &:first-child {
      margin-right: 40px;
    }

    &.turn-off-pay:first-child {
      margin-right: 40px;
    }
  }
`;

const CurrentPaymentButtonsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 32px;

  @media (max-width: 474px) {
    &:first-child {
      min-width: 100%;
      max-width: 100%;
    }

    &:last-child {
      min-width: 100%;
      max-width: 100%;
    }
  }

  @media (min-width: 475px) {
    flex-direction: row;
  }
`;

const CurrentPaymentConnectBankWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 14px;
  margin-bottom: 32px;
  width: 100%;

  @media (min-width: ${(props) => props.theme.breakpoint.sm}px) {
  }

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
  }
`;

const CurrentPaymentLabel = styled.h4`
  color: ${(props) => props.theme.color.neutral.v500};
  padding: 0;
  margin: 0;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 16px;
`;

const CurrentPaymentDueDateLabel = styled.h4`
  color: ${(props) => props.theme.color.neutral.v500};
  padding: 0;
  margin: 0;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 24px;
`;

const CurrentPaymentValue = styled.div`
  color: ${(props) => props.theme.color.primary.v600};
  padding: 0;
  margin: 0;
  font-weight: bold;
  font-size: 18px;
  line-height: 28px;
  display: flex;
  align-items: center;
`;

const ConnectBankValue = styled.div`
  color: ${(props) => props.theme.color.primary.v600};
  padding: 0;
  margin: 0;
  font-weight: bold;
  font-size: 16px;
  line-height: 20px;
  display: flex;
  align-items: center;
  margin-bottom: 16px;
`;

const PastDueStyle = styled(CurrentPaymentValue)`
  color: #e03131; // red-2  https://showroom.cvnacorp.com/carvana-css-theme
`;

const CurrentPaymentButton = css`
  padding: 0 10px;
  min-width: 165px;
  min-height: 40px;
  font-size: 14px;

  &:first-child {
    margin-right: 20px;
  }

  &.turn-off-pay:first-child {
    min-width: 185px;
  }

  @media (max-width: 475px) {
    min-width: 100%;
    max-width: 100%;

    &:first-child {
      margin-bottom: 16px;
    }
  }

  @media (min-width: 476px) {
    min-width: 145px;
    max-width: 145px;
  }

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    margin-right: 40px;
    min-width: 165px;

    &:first-child {
      margin-right: 40px;
    }
  }
`;

const CurrentPaymentMakePaymentButton = styled(PrimaryButton)`
  ${CurrentPaymentButton}
  min-width: 165px;
`;

const CurrentPaymentAutopayButton = styled(SecondaryButton)`
  ${CurrentPaymentButton}
`;

const CurrentPaymentTurnOffButton = styled(SecondaryButton)`
  ${CurrentPaymentButton}
  min-width: 185px;
  @media (min-width: ${(props) => props.theme.breakpoint.xs}px) {
    min-width: 185px;
  }
`;

const CurrentPaymentConnectGetStartedButton = styled(PrimaryButton)`
  ${CurrentPaymentButton}
  min-width: 185px;
  margin-bottom: 0px;

  @media (max-width: 475px) {
    margin-bottom: 0;
  }
  @media (min-width: 476px) {
    margin-bottom: 0;
  }
  @media (min-width: ${(props) => props.theme.breakpoint.sm}px) {
    min-width: 185px;
  }
`;

export {
  CurrentPaymentWrapper,
  CurrentPaymentTitle,
  CurrentPaymentLabel,
  CurrentPaymentDetailsWrapper,
  CurrentPaymentDetails,
  CurrentPaymentButtonsWrapper,
  CurrentPaymentValue,
  PastDueStyle,
  CurrentPaymentAutopayButton,
  CurrentPaymentTurnOffButton,
  CurrentPaymentMakePaymentButton,
  CurrentPaymentConnectBankWrapper,
  CurrentPaymentConnectGetStartedButton,
  CurrentPaymentDueDateLabel,
  PaymentTooltip,
  ConnectBankValue,
};
